module.exports = __webpack_public_path__ + "static/media/nz.792c5cf0.svg";